module.exports = __webpack_public_path__ + "media/images/company/cp08-8a18ccbfdb2b078fb9ec31c355cd97ed.png";